const DEFAULT_VALID_TAGS = ['P', 'LI', 'H2', 'H3', 'H4'];

export const isValidElement = (
  element: Element,
  validTags: string[] = DEFAULT_VALID_TAGS
): boolean => {
  if (!element) return false;

  return validTags.includes(element.tagName);
};

export const findAllValidElements = (
  root: Element,
  validTags: string[] = DEFAULT_VALID_TAGS
): Element[] => {
  const results: Element[] = [];

  const recursiveSearch = (element: Element) => {
    if (isValidElement(element, validTags)) {
      results.push(element);
    }
    Array.from(element.children).forEach(recursiveSearch);
  };

  recursiveSearch(root);
  return results;
};
